import React, { useMemo } from 'react';

import isFunction from 'lodash/isFunction';

import { Typography, Card, CardContent, Stack } from '@gogame/components';
import { useCurrencyFormat, usePercentFormat } from '@gogame/intl-ts';

import Empty from 'scenes/Gallery/components/Empty';

const PerformanceItem = ({ value, label, type, precision }) => {
  const formatCurrency = useCurrencyFormat();
  const formatPercent = usePercentFormat({ precision });

  const displayValue = useMemo(() => {
    switch (type) {
      case 'currency':
        return formatCurrency(value);
      case 'percent':
        return formatPercent(value);
    }
  }, [value, type]);

  return (
    <Stack height={'100%'}>
      <Card elevation={6} fullHeight={true}>
        <CardContent fullHeight={true}>
          {label ? (
            <Typography variant={'caption'} component={'div'}>
              {label}
            </Typography>
          ) : null}
          {displayValue ? (
            <Typography variant={'h6'}>{displayValue}</Typography>
          ) : isFunction(type) ? (
            type({ value })
          ) : (
            <Empty />
          )}
        </CardContent>
      </Card>
    </Stack>
  );
};

export default PerformanceItem;
